// Angular imports
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

// Librairies imports
import { Gs1ComponentsLibraryModule, GS1LayoutModule } from '@gs1france/gs1-components-library'; // You can only import submodules if you don't need everything, same as in the styles import;
import { NgSelectModule } from '@ng-select/ng-select'; // To use inside gs1-select-wrapper
import { OAuthModule, OAuthService, OAuthStorage } from 'angular-oauth2-oidc';

// App imports
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { AuthService } from './core/services/auth/auth.service';
import { AuthInterceptor } from './core/services/auth-interceptor/auth.interceptor';
import { GLNService } from './core/services/gln/gln.service';
import { HubModule } from './hub/hub.module';
import { AuthGuardService } from './core/guards/auth.guard';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ContactService } from './core/services/contact/contact.service';
import { GoogleMapsModule } from '@angular/google-maps';
 


@NgModule({
  declarations: [
    AppComponent 
  ],
  imports: [
    BrowserModule, BrowserAnimationsModule, CommonModule,
    HttpClientModule,
    AppRoutingModule,
    OAuthModule.forRoot(),
    Gs1ComponentsLibraryModule.forRoot(), GS1LayoutModule,
    NgSelectModule,
    CoreModule, HubModule,
   GoogleMapsModule,    
  ],
  providers: [
    { provide: OAuthStorage, useFactory: getLocalStorage },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    AuthService, GLNService, ContactService,
    OAuthService,
    AuthGuardService,
    {provide: 'googleTagManagerId', useValue: 'GTM-MRWFXTG'},
    {provide: APP_INITIALIZER, useFactory: (initService: AuthService) => initService.initAuth(), deps: [AuthService], multi: true}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function getLocalStorage() {
  return (typeof window !== "undefined") ? window.localStorage : null;
}
